import authService from '../../services/auth-service'

//const user = localStorage.user;
//const isAdmin = localStorage.isAdmin;
// const initialState = user ? {
//     loading: false,
//     error: null,
//     user: JSON.parse(user),
//     // isAdmin: JSON.parse(isAdmin)
// } : {
//     loading: false,
//     error: null,
//     user: null,
//     //isAdmin: null
// };

const state = {
    //initialState,
    loading: false,
    authState:false,
    error: null,
    user: {},
    shopAccess: {
        shoplink: "",
        shopAccessKey: ""
    }
}

const actions = {
    login({ dispatch, commit }, data) {
        commit('Loading', true)
        authService.login(data)
            .then(
                response => {
                    if (response) {
                        commit('Success', response.data)
                        //ls.user = JSON.stringify(response.data) // saving user details in local storage
                        commit('Loading', false)
                    } else {
                        commit('Loading', false)
                        commit('Failure', "undefined");
                    }



                },
                error => {
                    commit('Loading', false)
                    commit('Failure', error);

                }
            );
    },
    logout({ dispatch, commit }) {
        // authService.logout();
        //localStorage.removeItem('isAdmin')
        commit('Logout');
        dispatch('Layouts/set_layout', 'simple-layout', {
            root: true
        })
        // router.push({
        //     name: 'login'
        // });
    },
    disableUser({ dispatch, commit }) {

    },
    setShopAccess({ commit }, data) {
        commit('SetShopAccess', data)
    }
}

const mutations = {
    Loading(state, value) {
        state.loading = value;

    },
    Success(state, user) {
       
        state.user = user;
        state.authState=true;

    },
    Failure(state, error) {
        state.error = error;
    },
    Logout(state) {
        state.user = null;
        state.authState=false;
    },
    SetShopAccess(state, data) {
        state.shopAccess.shoplink = data.shoplink
        state.shopAccess.shopAccessKey = data.shopAccessKey
    }
}


const getters = {
    CURRENT_USER: state => {
        return state.user
    },

    LOGIN_ERRORS: state => {
        return state.error
    },
    LOGIN_LOADING: state => {
        return state.loading
    },
    SHOP_ACCESS:state=>{
        return state.shopAccess
    }


}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}